import { baseRestApi } from "api/rest/baseRestApi";
import { PaginatedApiRequestQueryArgs } from "api/rest/types/requests";
import enhanceWithPagination from "utils/enhanceWithPagination";
import paramsToTuples from "utils/paramsToTuples";

import { ApiResponsePaginatedCursor } from "../types/responses";
import { Tag } from "./types";

module.hot?.accept();

type FindManyTagsQueryArgs = PaginatedApiRequestQueryArgs<{
  queryParams: {
    search?: string;
    ids?: string[];
  };
}>;

const findManyTags = baseRestApi.enhanceEndpoints({ addTagTypes: ["TAGS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    findManyTags: builder.query<ApiResponsePaginatedCursor<{ tags: Tag[] }>, FindManyTagsQueryArgs>({
      query: ({ queryParams }) => ({
        method: "GET",
        url: `shipper/tags`,
        params: paramsToTuples(queryParams),
      }),
      providesTags: ["TAGS"],
    }),
  }),
});

export const { useFindManyTagsQuery, useLazyFindManyTagsQuery } = findManyTags;

export const { useFindManyTagsQuery: usePaginatedFindManyTagsQuery } = enhanceWithPagination(
  findManyTags,
  "findManyTags"
);
